export const STAR_SEGMENTS_COUNT = 10;
export const STAR_SEGMENT_WIDTH = 100 / STAR_SEGMENTS_COUNT;